import React from "react";
import { MdOutlineFileDownload } from "react-icons/md";
import { useSelector } from "react-redux";
import { handleNavRoutings } from "../../../utils/constants/Navbar";
import { handleDownloadAppClickedEvent } from "../../../utils/helperEventFunctions";
import { useRouter } from "next/router";
import useStore from "../../../store/UseStore";
import Link from "next/link";

const DesktopNav = () => {
  const { setOpenQRModal } = useStore();
  const router = useRouter();
  const firebaseUID = useSelector((state) => state.currentUser.firebaseUID);
  const sourceScreen = router?.query ? router.asPath : router?.pathname;
  return (
    <div className="flex justify-between container mx-auto items-center py-3">
      <Link href="/">
        <img
          src="/assets/headerlogo.webp"
          alt="seekho"
          className="w-[130px] hover:cursor-pointer"
        />
      </Link>
      <div className="flex gap-x-10 items-center">
        {handleNavRoutings().map(
          (item) =>
            item.display && (
              <Link href={item?.link} key={item?.title} passHref>
                <a className="text-[16px] text-[#b8b8b8] no-underline !font-extralight font-lexend hover:text-[#b8b8b8]">
                  {item?.title}
                </a>
              </Link>
            )
        )}
        <button
          onClick={() => {
            handleDownloadAppClickedEvent({
              firebaseUID,
              desktopStatus: "NavBar_CTA",
              sourceScreen,
              anonymousId: "",
            });

            setOpenQRModal({ open: true, fromSection: "Navbar" });
          }}
          className="border text-[16px] px-3 py-[8px] rounded-[11px] bg-white text-black flex items-center gap-x-2 font-medium font-lexend"
        >
          <MdOutlineFileDownload className="text-[24px]" /> Download App
        </button>
      </div>
    </div>
  );
};

export default DesktopNav;
